module.exports = __webpack_public_path__ + "static/media/ceo_banner_zh.97754078.png";